import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ObstacleModel } from '../../models';
import {
    All as Action,
    TYPE,
    WIDTH,
    FISH,
    TypeResults,
    WidthResults,
    FishResults,
    Failure,
    SPAM
} from '../actions/classification.actions';
import { ApiService } from '../../services';
import { State } from '../reducers';

@Injectable()
export class ClassificationEffects {

    @Effect() classify$ = this.actions$
        .ofType(TYPE, WIDTH, FISH)
        .withLatestFrom(this.store.select(state => state.obstacles.current))
        .switchMap(([action, current]: [Action, ObstacleModel]) => {
            if (current === null) {
                return Observable.of(new Failure('No current obstacle'));
            } else {
                switch (action.type) {
                    case TYPE: {
                        return this.api.classifyType(current.id, action.barrierType)
                            .mergeMap(() => this.api.getTypeResults(current.id))
                            .mergeMap(results => Observable.of(new TypeResults(results.data, results.labels)))
                            .catch(err => Observable.of(new Failure(err)));
                    }
                    case WIDTH: {
                        return this.api.classifyWidth(current.id, action.isFullWidth)
                            .mergeMap(() => this.api.getWidthResults(current.id))
                            .mergeMap(results => Observable.of(new WidthResults(results.data, results.labels)))
                            .catch(err => Observable.of(new Failure(err)));
                    }
                    case FISH: {
                        return this.api.classifyFish(current.id, action.hasFishPass)
                            .mergeMap(() => this.api.getFishResults(current.id))
                            .mergeMap(results => Observable.of(new FishResults(results.data, results.labels)))
                            .catch(err => Observable.of(new Failure(err)));
                    }
                }
            }
        });

    @Effect({ dispatch: false }) flagSpam$ = this.actions$
        .ofType(SPAM)
        .withLatestFrom(this.store.select(state => state.obstacles.current))
        .do(([_, current]) => {
            this.api.classifySpam(current.id).subscribe();
        });

    constructor(
        private actions$: Actions,
        private api: ApiService,
        private store: Store<State>
    ) {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/effects/classification.effects.ts